<template >
  <div>
    <div class="filters-holder">
      <div class="d-flex flex-row mt-3">
        <div class="flex-fill">
          <b-nav class="nav--customers"
            ><b-nav-item
              v-for="(item, idx) in items"
              :key="idx"
              :active="
                (idx === 0 && !dispenseStatusSlug && !itemStatusSlug) ||
                (dispenseStatusSlug === item.slug && !itemStatusSlug) ||
                (itemStatusSlug === item.slug && !dispenseStatusSlug) ||
                (item.customFilter && $route.query.customFilter === item.slug)
              "
              @click="onChange(item)"
              ><b-badge
                class="mr-2"
                pill="pill"
                :variant="item.slug === 'late-orders' ? 'danger' : undefined"
                >{{ item.total | numeral('0a') }}</b-badge
              >{{ item.display_name }}</b-nav-item
            ></b-nav
          >
        </div>
      </div>
    </div>
    <div class="table-filter">
      <div class="filters-holder">
        <b-form @submit.stop.prevent="submit"
          ><div class="search-type-tabs">
            <span
              class="search-type-tab"
              :class="{ active: searchType === 'all' }"
              @click="setSearchType('all')"
              >All</span
            >
            <span
              class="search-type-tab"
              :class="{ active: searchType === 'job' }"
              @click="setSearchType('job')"
              >Job ID</span
            >
            <span
              class="search-type-tab"
              :class="{ active: searchType === 'order' }"
              @click="setSearchType('order')"
              >Order Item ID</span
            >
          </div>
          <div class="search-form">
            <ClearableInput
              name="q"
              :placeholder="searchPlaceholder"
              v-model="q"
              @input-cleared="onInputCleared"
              @enter="submit"
              ><template v-slot:prepend
                ><b-input-group-text class="px-3" size="lg"
                  ><i class="di-search-18"></i></b-input-group-text></template
            ></ClearableInput>
            <b-dropdown
              v-if="searchType === 'all'"
              block="block"
              size="lg"
              menu-class="dropdown-menu--location"
              variant="floating"
              ><template v-slot:button-content
                ><span class="btn__label">Country</span
                ><span class="btn__value">{{ _.get(region, 'name', 'Any') }}</span></template
              >
              <b-dropdown-item-button @click="regionId = null"
                ><span>All Countries</span></b-dropdown-item-button
              >
              <b-dropdown-item-button
                v-for="region in $store.getters.locationSelectorRegions"
                :key="region.id"
                @click="regionId = region.id"
                ><span class="text-muted">{{ region.name }}</span></b-dropdown-item-button
              >
            </b-dropdown>
            <b-button variant="primary" type="button" @click="submit" size="lg">Search</b-button>
          </div>
          <div class="search-no-results" v-if="noResultsMessage">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 1.25C6.66498 1.25 5.35994 1.64588 4.2499 2.38758C3.13987 3.12928 2.27471 4.18349 1.76382 5.41689C1.25292 6.65029 1.11925 8.00749 1.3797 9.31686C1.64015 10.6262 2.28303 11.829 3.22703 12.773C4.17104 13.717 5.37377 14.3598 6.68314 14.6203C7.99252 14.8808 9.34971 14.7471 10.5831 14.2362C11.8165 13.7253 12.8707 12.8601 13.6124 11.7501C14.3541 10.6401 14.75 9.33502 14.75 8C14.748 6.2104 14.0362 4.49466 12.7708 3.22922C11.5053 1.96378 9.78961 1.25199 8 1.25ZM8 13.25C6.96165 13.25 5.94662 12.9421 5.08326 12.3652C4.2199 11.7883 3.547 10.9684 3.14964 10.0091C2.75228 9.04978 2.64831 7.99418 2.85088 6.97578C3.05345 5.95738 3.55347 5.02191 4.28769 4.28769C5.02192 3.55346 5.95738 3.05345 6.97578 2.85088C7.99418 2.6483 9.04978 2.75227 10.0091 3.14963C10.9684 3.54699 11.7883 4.2199 12.3652 5.08326C12.9421 5.94661 13.25 6.96165 13.25 8C13.2485 9.39193 12.6949 10.7264 11.7107 11.7107C10.7264 12.6949 9.39193 13.2485 8 13.25ZM7.25 8.25V5C7.25 4.80109 7.32902 4.61032 7.46967 4.46967C7.61032 4.32902 7.80109 4.25 8 4.25C8.19891 4.25 8.38968 4.32902 8.53033 4.46967C8.67098 4.61032 8.75 4.80109 8.75 5V8.25C8.75 8.44891 8.67098 8.63968 8.53033 8.78033C8.38968 8.92098 8.19891 9 8 9C7.80109 9 7.61032 8.92098 7.46967 8.78033C7.32902 8.63968 7.25 8.44891 7.25 8.25ZM9 10.75C9 10.9478 8.94135 11.1411 8.83147 11.3056C8.72159 11.47 8.56541 11.5982 8.38269 11.6739C8.19996 11.7496 7.99889 11.7694 7.80491 11.7308C7.61093 11.6922 7.43275 11.597 7.2929 11.4571C7.15304 11.3173 7.0578 11.1391 7.01922 10.9451C6.98063 10.7511 7.00044 10.55 7.07612 10.3673C7.15181 10.1846 7.27998 10.0284 7.44443 9.91853C7.60888 9.80865 7.80222 9.75 8 9.75C8.26522 9.75 8.51957 9.85536 8.70711 10.0429C8.89465 10.2304 9 10.4848 9 10.75Z" fill="#FF8200"/>
            </svg>
            <span>{{ noResultsMessage }}</span>
          </div>
          <div class="d-flex mt-2-5">
            <b-button class="bubble-wrapper" variant="filter" v-b-toggle.filters
              ><i class="di-filter-18 mr-2"></i>Filters<span
                class="bubble bubble--danger"
                v-if="totalFilters > 0"
                >{{ totalFilters }}</span
              ></b-button
            >
            <b-dropdown
              class="ml-3"
              variant="filter"
              size="sms"
              no-caret="no-caret"
              :class="{ 'btn-select-filter': !selectedFilter }"
              ><template v-slot:button-content
                ><i class="di-search-18 mr-2"></i>Saved Searches</template
              >
              <div class="text-muted text-center" v-show="savedFilterNames.length === 0">Empty</div>
              <b-dropdown-item-button
                v-for="name in savedFilterNames"
                :key="name"
                :value="name"
                @click="onSelectSavedFilter"
                :active="selectedFilter === name"
                >{{ name
                }}<i
                  class="di-remove-10 float-right"
                  @click.stop.prevent="() => removeFilter(name)"
                ></i
              ></b-dropdown-item-button>
            </b-dropdown>
            <b-button
              class="ml-auto"
              variant="clear-filter"
              @click="onClearFilter"
              v-if="totalFilters > 0"
              ><i class="di-remove-10 mr-2"></i>Clear filters</b-button
            >
          </div>
          <b-collapse id="filters" :visible="totalFilters > 0">
            <div class="border-0 pt-2-5">
              <b-row class="row--6px">
                <b-col cols="3">
                  <b-dropdown
                    block="block"
                    size="lg"
                    menu-class="dropdown-menu--location"
                    variant="floating"
                    ><template v-slot:button-content=""
                      ><span class="btn__label">Assigned Outlet</span
                      ><span class="btn__value">{{ selectedOutlets }}</span></template
                    >
                    <div
                      class="dropdown-item bg-white text-body"
                      v-for="outlet in filteredOutlets"
                      :key="outlet.id"
                    >
                      <b-form-checkbox class="checkbox-filter" :value="outlet.id" v-model="outletId"
                        ><span class="outlet-abbr text-uppercase">{{ outlet.abbreviation }}</span
                        ><span class="text-muted">{{ outlet.name }}</span></b-form-checkbox
                      >
                    </div>
                  </b-dropdown>
                </b-col>
                <b-col cols="3">
                  <b-dropdown
                    block="block"
                    size="lg"
                    menu-class="dropdown-menu--location"
                    variant="floating"
                    ><template v-slot:button-content
                      ><span class="btn__label">Order Status</span
                      ><span class="btn__value">{{ dispenseStatus }}</span></template
                    >
                    <div
                      class="dropdown-item bg-white text-body"
                      v-for="status in orderDispenseStatuses"
                      :key="status.slug"
                    >
                      <b-form-checkbox
                        class="checkbox-filter"
                        :value="status.slug"
                        v-model="dispenseStatusSlug"
                        ><span>{{ status.display_name }}</span></b-form-checkbox
                      >
                    </div>
                  </b-dropdown>
                </b-col>
                <b-col cols="3">
                  <b-dropdown
                    block="block"
                    size="lg"
                    menu-class="dropdown-menu--location"
                    variant="floating"
                    ><template v-slot:button-content
                      ><span class="btn__label">Item Status</span
                      ><span class="btn__value">{{ itemStatus }}</span></template
                    >
                    <div
                      class="dropdown-item bg-white text-body"
                      v-for="status in orderItemStatuses"
                      :key="status.slug"
                    >
                      <b-form-checkbox
                        class="checkbox-filter"
                        :value="status.slug"
                        v-model="itemStatusSlug"
                        ><span>{{ status.display_name }}</span></b-form-checkbox
                      >
                    </div>
                  </b-dropdown>
                </b-col>
                <b-col cols="3">
                  <b-form-group class="form-group--floating-label mb-0" label-for="date">
                    <vc-date-picker
                      class="custom-date-picker custom-date-picker--lg"
                      mode="range"
                      v-model="createdAt"
                      :attributes="datePicker.attributes"
                      :masks="datePicker.masks"
                      :popover="{ visibility: 'click' }"
                      :input-props="{ placeholder: 'Any', class: 'placeholder--black' }"
                      is-range
                    >
                      <template v-slot="{ inputValue, inputEvents }">
                        <div style="display: flex; justify-content: center; align-items: center">
                          <input
                            class="bg-white border px-2 py-1 rounded w-100"
                            :value="formattedRange(inputValue)"
                            v-on="inputEvents.start"
                            placeholder="Select Date Range"
                            readonly
                          />
                        </div>
                      </template>
                    </vc-date-picker>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="mt-3" align-h="between" align-v="center">
                <b-col cols="3">
                  <b-dropdown
                    block="block"
                    size="lg"
                    menu-class="dropdown-menu--location"
                    variant="floating"
                    ><template v-slot:button-content=""
                      ><span class="btn__label">Original Outlet</span
                      ><span class="btn__value">{{ selectedOriginalOutlets }}</span></template
                    >
                    <div
                      class="dropdown-item bg-white text-body"
                      v-for="outlet in filteredOutlets"
                      :key="outlet.id"
                    >
                      <b-form-checkbox class="checkbox-filter" :value="outlet.id" v-model="originOutletId"
                        ><span class="outlet-abbr text-uppercase">{{ outlet.abbreviation }}</span
                        ><span class="text-muted">{{ outlet.name }}</span></b-form-checkbox
                      >
                    </div>
                  </b-dropdown>
                </b-col>
                <b-col cols="3">
                  <b-form-checkbox
                    class="checkbox-filter"
                    :value="2"
                    :unchecked-value="null"
                    v-model="priority"
                    ><span>Priority</span></b-form-checkbox
                  >
                </b-col>
                <b-col cols="auto">
                  <SaveFilterPopover
                    target="btn-save-filter"
                    :query="currentFilters"
                    :addFilter="addJobFilter"
                  ></SaveFilterPopover>
                  <b-button variant="link" type="button" id="btn-save-filter">Save Search</b-button>
                  <b-button variant="primary" type="button" @click="submit">Apply Filters</b-button>
                </b-col>
              </b-row>
            </div>
          </b-collapse>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import orderApi from '@/api/orders';
import ClearableInput from '@/components/ClearableInput.vue';
import SaveFilterPopover from '@/components/modals/SaveFilterPopover.vue';

export default {
  name: 'JobsFilter',
  components: {
    ClearableInput,
    SaveFilterPopover,
  },
  props: {
    resultCount: {
      type: Number,
      default: null,
    },
  },
  data() {
    const { query } = this.$route;
    let createdStartAt = null;
    let createdEndAt = null;
    if (query.created_start_at) {
      createdStartAt = this.$moment(query.created_start_at).startOf('day').toDate();
    }
    if (query.created_end_at) {
      createdEndAt = this.$moment(query.created_end_at).startOf('day').toDate();
    }
    return {
      datePicker: {
        popover: {
          placement: 'bottom-end',
        },
        masks: {
          weekdays: 'WW',
          input: ['MMM DD'],
          data: ['DD/MM/YYYY'],
        },
        attributes: [
          {
            dot: {
              color: 'blue',
            },
            contentClass: 'text-semi-bold text-gray-950',
            dates: [new Date()],
          },
          {
            highlight: {
              class: 'bg-white',
              contentClass: 'text-semi-bold text-gray-950',
            },
            dates: [new Date()],
          },
          {
            popover: {
              visibility: 'hover',
              hideIndicator: true,
            },
            dates: [new Date()],
          },
        ],
      },
      regionId: query.region_id,
      q: null,
      items: [],
      outletId: query.outlet_id?.split(',').map(Number) || [],
      originOutletId: query.origin_outlet_id?.split(',').map(Number) || [],
      itemStatusSlug: query.item_dispense_status_id?.split(',') || [],
      dispenseStatusSlug: query.dispense_status_id?.split(',') || [],
      priority: query.priority,
      createdAt: {
        start: createdStartAt,
        end: createdEndAt,
      },
      selectedFilter: null,
      searchType: query.search_type || 'all',
      noResultsMessage: null,
    };
  },
  async created() {
    this.q = this.$route.query.q || null;
    this.items = await orderApi.getTotalOrders();
  },
  methods: {
    formattedRange(inputValue) {
      if (!inputValue.start && !inputValue.end) {
        return '';
      }
      const start = inputValue.start ? inputValue.start : '';
      const end = inputValue.end ? inputValue.end : '';
      return `${start} - ${end}`;
    },
    ...mapMutations({
      addJobFilter: 'ADD_JOB_FILTER',
      removeJobFilter: 'REMOVE_JOB_FILTER',
    }),
    onChange(statusObj) {
      let query = {
        ...this.$route.query,
        dispense_status_id: null,
        item_dispense_status_id: null,
        page: 1,
        customFilter: null,
        sort_direction: 'desc',
        sort_by: 'created_at',
      };

      if (statusObj.customFilter) {
        query.customFilter = statusObj.slug;
        query = {
          ...query,
          ...(statusObj.defaultQuery || {}),
        };
      } else {
        query[statusObj.filter_type] = statusObj.slug;
      }

      this.$router.push({
        name: this.$route.name,
        query,
      });
    },
    onClearFilter() {
      this.selectedFilter = null;
      this.noResultsMessage = null;
      this.$router.push({
        name: this.$route.name,
        query: {
          ...this.$route.query,
          region_id: null,
          outlet_id: null,
          origin_outlet_id: null,
          dispense_status_id: null,
          item_dispense_status_id: null,
          created_start_at: null,
          created_end_at: null,
          page: 1,
          priority: null,
          customer_id: null,
          search_type: 'all',
        },
      });
    },
    setSearchType(type) {
      this.searchType = type;
      this.noResultsMessage = null;
    },
    onInputCleared() {
      this.searchType = 'all';
      this.noResultsMessage = null;
      this.submit();
    },
    submit() {
      this.noResultsMessage = null;
      this.applyFilters(this.currentFilters);
    },
    onSelectSavedFilter(e) {
      this.selectedFilter = e.target.value;
      this.applyFilters(this.jobFilters[this.selectedFilter]);
    },
    applyFilters(query) {
      this.$router.push({
        name: this.$route.name,
        query: {
          ...query,
          search_type: this.searchType,
          dispense_status_id: null,
          ...(query.dispense_status_id?.length && {
            dispense_status_id: query.dispense_status_id.join(','),
          }),
          item_dispense_status_id: null,
          ...(query.item_dispense_status_id?.length && {
            item_dispense_status_id: query.item_dispense_status_id.join(','),
          }),
          outlet_id: null,
          origin_outlet_id: null,
          customer_id: null,
          ...(query.outlet_id?.length && { outlet_id: query.outlet_id.join(',') }),
          ...(query.origin_outlet_id?.length && { origin_outlet_id: query.origin_outlet_id.join(',') }),
        },
      });
    },
    removeFilter(filterName) {
      this.$bvModal
        .msgBoxConfirm(`Are you sure to remove filter '${filterName}'?`, {
          title: 'Please confirm',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelVariant: 'outline-secondary',
          cancelTitle: 'No',
          hideHeaderClose: false,
          centered: true,
          headerClass: 'border-bottom p-3',
          bodyClass: 'px-4 py-2',
          footerClass: 'bg-white py-2 justify-content-center',
        })
        .then(isConfirmed => {
          if (isConfirmed) {
            this.removeJobFilter(filterName);
          }
        });
    },
  },
  computed: {
    ...mapState(['outlets', 'jobFilters', 'orderDispenseStatuses', 'orderItemStatuses']),
    ...mapGetters(['locationSelectorRegions']),
    ...mapGetters('auth', ['locationSelectorOutlets']),
    filteredOutlets() {
      return (
        this.regionId
          ? this.outlets.filter(outlet => outlet.region_id === this.regionId)
          : this.outlets
      ).filter(outlet => outlet.is_active || outlet.name === 'Newtown' || outlet.name === 'Union Station'  || outlet.name === 'Hamilton')
      .sort((a, b) => a.name.localeCompare(b.name));
    },
    createdStartAt() {
      if (!this.createdAt.start) {
        return null;
      }
      return this.$moment(this.createdAt.start).utc().startOf('day').toISOString();
    },
    createdEndAt() {
      if (!this.createdAt.end) {
        return null;
      }
      return this.$moment(this.createdAt.end).utc().endOf('day').toISOString();
    },
    region() {
      if (!this.regionId) return {};
      return this.locationSelectorRegions.find(region => region.id === parseInt(this.regionId, 10));
    },
    selectedOutlets() {
      return (
        this.outlets
          .filter(({ id }) => this.outletId.includes(id))
          .map(o => o.abbreviation)
          .join(', ') || 'Any'
      );
    },
    selectedOriginalOutlets() {
      return (
        this.outlets
          .filter(({ id }) => this.originOutletId.includes(id))
          .map(o => o.abbreviation)
          .join(', ') || 'Any'
      );
    },
    itemStatus() {
      return (
        this.orderItemStatuses
          .filter(({ slug }) => this.itemStatusSlug.includes(slug))
          .map(s => s.display_name)
          .join(', ') || 'Any'
      );
    },
    dispenseStatus() {
      return (
        this.orderDispenseStatuses
          .filter(({ slug }) => this.dispenseStatusSlug.includes(slug))
          .map(s => s.display_name)
          .join(', ') || 'Any'
      );
    },
    totalFilters() {
      let total = 0;
      total += this.outletId.length && 1;
      total += this.originOutletId.length && 1;
      total += this.itemStatusSlug.length && 1;
      total += this.dispenseStatusSlug.length && 1;
      total += this.createdAt.start && 1;
      total += Number(this.priority) === 2 && 1;
      return total;
    },
    searchPlaceholder() {
      if (this.searchType === 'job') {
        return 'AU-O405315-SER or O405315';
      }
      if (this.searchType === 'order') {
        return 'Enter Order Item ID (e.g. 907517)';
      }
      return 'Search by name, phone, e-mail, or invoice number';
    },
    currentFilters() {
      return {
        ...this.$route.query,
        q: this.q,
        search_type: this.searchType,
        region_id: this.regionId,
        outlet_id: this.outletId,
        origin_outlet_id: this.originOutletId,
        item_dispense_status_id: this.itemStatusSlug,
        dispense_status_id: this.dispenseStatusSlug,
        created_start_at: this.createdStartAt,
        created_end_at: this.createdEndAt,
        priority: this.priority,
        r: this._.random(0, 100),
        page: 1,
      };
    },
    savedFilterNames() {
      return Object.keys(this.jobFilters);
    },
    converDate(date) {
      date.setDate(date.getDate());
      let year = date.getFullYear();
      let month = String(date.getMonth() + 1).padStart(2, '0');
      let day = String(date.getDate()).padStart(2, '0');
      let formattedDate = `${year}-${month}-${day}`;
      return formattedDate + 'T00:00:00.000Z';
    },
  },
  watch: {
    $route(to) {
      let createdStartAt = null;
      let createdEndAt = null;
      if (to.query.created_start_at) {
        createdStartAt = converDate(to.query.created_start_at);
      }
      if (to.query.created_end_at) {
        createdEndAt = converDate(to.query.created_end_at);
      }
      this.q = to.query.q || null;
      this.searchType = to.query.search_type || 'all';
      this.regionId = to.query.region_id || null;
      this.outletId = to.query.outlet_id?.split(',').map(Number) || [];
      this.originOutletId = to.query.origin_outlet_id?.split(',').map(Number) || [];
      this.itemStatusSlug = to.query.item_dispense_status_id?.split(',') || [];
      this.dispenseStatusSlug = to.query.dispense_status_id?.split(',') || [];
      this.createdAt = {
        start: createdStartAt,
        end: createdEndAt,
      };
      this.priority = to.query.priority;
    },
    resultCount(count) {
      if (count === 0 && this.q && this.searchType !== 'all') {
        if (this.searchType === 'job') {
          this.noResultsMessage = 'No order found with that Job ID. Please check case.';
        } else if (this.searchType === 'order') {
          this.noResultsMessage = 'No order found with that Order Item ID. Please check case.';
        }
      } else {
        this.noResultsMessage = null;
      }
    },
    currentFilters(query) {
      const isSelectedFilter = this._.some(Object.values(this.jobFilters), filter =>
        this._.isEqual(this._.omit(filter, ['r']), this._.omit(query, ['r'])),
      );
      if (!isSelectedFilter) {
        this.selectedFilter = null;
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';

.search-type-tabs {
  display: flex;
  gap: 16px;
  margin-bottom: 8px;
}

.search-type-tab {
  font-size: 14px;
  color: $gray-550;
  cursor: pointer;
  padding-bottom: 4px;
  border-bottom: 2px solid transparent;

  &.active {
    color: #1b1f26;
    font-weight: 600;
    border-bottom-color: #1b1f26;
  }

  &:hover:not(.active) {
    color: #1b1f26;
  }
}

.search-no-results {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  font-size: 14px;
  color: #FF8200;
}

.btn-select-filter {
  .btn {
    background-color: transparent !important;
    color: $gray-550;
    i {
      color: $gray-550;
    }
  }
  .dropdown-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .di-remove-10 {
    font-size: 10px;
    &:hover {
      color: red;
    }
  }
}

.outlet-abbr {
  width: 50px;
  display: inline-block;
}

.checkbox-filter {
  .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
    border-color: #adb5bd;
  }
  .custom-control-label {
    &::before {
      background-color: #fff;
      top: -4px;
      border-radius: 4px !important;
    }
    &::after {
      top: -4px;
    }
    span {
      color: #1b1f26;
      font-size: 14px;
    }
  }
}
</style>
